<template>
	<div class='repair-wrap'>
		<!-- <router-link class="repair-button" to="/user/repair">信用修复申请</router-link> -->

		<div class="flex tag-tabs">
			<div class="tabs" v-for="item in stateList" :key="item.id" :class="{active: state === item.id}" @click="appealChange(item.id)">{{item.title}}</div>
		</div>
		<div class="appeal-table">
			<div class="flex flex-row-between appeal-header">
				<p>修复主体</p>
				<p>修复主体类型</p>
				<p>修复类型</p>
				<p>修复日期</p>
				<p>操作</p>
			</div>
			<div class="appeal-body" v-for="(item, index) in list" :key="index">
				<div class="flex flex-row-between">
					<p>{{item.name}}</p>
					<p>{{item.type}}</p>
					<p>{{formatApplyType(item.appealtype)}}</p>
					<p>{{item.applytime}}</p>
					<p @click="showHandle(item)">{{!item.show?'查看详情':'收起'}}</p>
				</div>
				<div class="flex flex-row-end" v-if="item.show">
					<el-button type="danger" @click="cancelHandle(item)" v-if="state===0">取消</el-button>
				</div>
				<div class="flex flex-row-between appeal-content" v-if="item.show">
					<div class="">
						<span class="label">修复主体名称：</span>
						<span class="content">{{item.name||'---'}}</span>
					</div>
					<div class="">
						<span class="label">统一社会信用代码/身份证号：</span>
						<span class="content">{{item.number||'---'}}</span>
					</div>
					<div class="">
						<span class="label">修复描述：</span>
						<span class="content">{{item.description||'---'}}</span>
					</div>
					<div class="">
						<span class="label">修复类型：</span>
						<span class="content">{{formatApplyType(item.appealtype)||'---'}}</span>
					</div>
					<div class="">
						<span class="label">修复时间：</span>
						<span class="content">{{item.applytime||'---'}}</span>
					</div>
					<div class="">
						<span class="label">修复状态：</span>
						<span class="content">{{formatState(state)||'---'}}</span>
					</div>
					<div class="">
						<span class="label">回复内容：</span>
						<span class="content">{{item.replydescription||'---'}}</span>
					</div>
					<div class="">
						<span class="label">回复文件：</span>
						<span class="content">{{formatFile(item.replyfile)||'---'}}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="flex flex-row-end pagination-wrap" v-if="list.length>0">
			<el-pagination background layout="total, prev, pager, next" :pageSize="pageSize" :total="total" @current-change="handleCurrentChange">
			</el-pagination>
		</div>

		<empty v-if="!list.length" />
	</div>
</template>

<script>
import empty from '@/components/empty';
import { myCreditRepairs, cancelRepair, repairDetail } from '@/api';

const stateList = Object.freeze([
	{ title: '待受理', id: 0 },
	{ title: '受理中', id: 1 },
	{ title: '已回复', id: 2 },
	{ title: '已驳回', id: 3 },
	{ title: '已取消', id: 4 },
])

export default {
	components: {
		empty,
	},
	data() {
		return {
			stateList,
			state: 0,
			list: [],
			pageSize: 10,
			total: undefined,
		}
	},
	created() {
		const { path } = this.$route;

		this.$emit('userEmit', path)
	},
	mounted() {
		this.getList(1);
	},
	methods: {
		appealChange(id) {
			this.$set(this, 'state', id);
			this.getList(1)
		},
		handleCurrentChange(e) {
			this.getList(e);
		},
		getList(page = 1) {
			myCreditRepairs({
				state: this.state, current: page
			}).then(res => {
				const { records, size, total, current } = res;
				this.$set(this, 'list', records || []);
				this.$set(this, 'total', total || 0);
			})
		},
		formatApplyType(type) {
			// 0信息概览，1 行政许可 2 行政处罚 3 守信红名单,4 失信黑名单,5 企业经营异常名录
			switch (+type) {
				case 0:
					return '信息概览'
				case 1:
					return '行政许可'
				case 2:
					return '行政处罚'
				case 3:
					return '守信红名单'
				case 4:
					return '失信黑名单'
				case 5:
					return '企业经营异常名录'
        case 6:
          return '合同履约'
				default:
					return '';
			}
		},
		formatState(state) {
			// 0 待受理，1 受理中，2 已回复 ，3 已驳回，4 已取消
			switch (+state) {
				case 0:
					return '待受理'
				case 1:
					return '受理中'
				case 2:
					return '已回复'
				case 3:
					return '已驳回'
				case 4:
					return '已取消'
				default:
					return '';
			}
		},
		formatFile(file = []) {
			return (file || []).map(item => item.name).join(',')
		},
		showHandle(row) {
			this.$set(row, 'show', !row.show);
			if (row.show) {
				// this.getDetail(row);
			}
		},
		getDetail({ id }) {
			repairDetail({ id }).then(res => {
			})
		},
		cancelHandle(row) {

			this.$confirm('是否取消本条信用修复记录？', '确认信息', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否'
			})
				.then(() => {
					const { id } = row;
					cancelRepair({ id }).then(res => {
						this.$message({
							message: '取消成功',
							type: 'success'
						});
					})
					this.getList();
				})
				.catch(action => {

				});
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.repair-wrap {
		position: relative;

		.repair-button {
			position: absolute;
			top: 20px;
			right: 0;
			background: $red;
			padding: 10px;
			border-radius: 4px;
			color: #fff;
			line-height: 1em;
		}
		.tag-tabs {
			width: 100%;
			& > .tabs {
				padding: 18px 30px;
				font-size: 18px;
				color: #222;
				cursor: pointer;
				&.active {
					color: $red;
					position: relative;
					&::after {
						content: '';
						width: 115px;
						height: 4px;
						background: $red;
						position: absolute;
						bottom: -4px;
						left: 0;
					}
				}
			}
		}

		.appeal-table {
			& > .appeal-header {
				font-size: 17px;
				font-weight: 400;
				background: #f4f4f4;
				border: 1px solid #e7e8ea;
				border-top: 4px solid #e7e8ea;
				p {
					padding: 18px 0;
					flex-basis: 20%;
					text-align: center;
					&:first-of-type {
						flex-basis: 35%;
					}
					// &:nth-child(2) {
					// 	flex-basis: 35%;
					// }
				}
			}

			& > .appeal-body {
				font-size: 14px;
				&:nth-child(odd) {
					&:not(.appeal-content) {
						background-color: #fbfbfb;
					}
				}
				p {
					cursor: pointer;
					padding: 10px 5px;
					flex-basis: 20%;
					text-align: center;
					&:first-of-type {
						flex-basis: 35%;
						text-align: left;
					}
					&:last-of-type {
						color: #e25670;
						&:hover {
							text-decoration: underline;
						}
					}
					// &:nth-child(2) {
					// 	flex-basis: 35%;
					// }
				}
			}

			.appeal-content {
				flex-wrap: wrap;
				& > div {
					flex: 50%;
					text-align: left;
					font-size: 14px;
					padding: 10px 0 10px 10%;
					& > .content {
						color: #e25670;
					}
				}
			}
		}
	}
</style>